module.exports = __webpack_public_path__ + "static/img/n9m0.eab4f7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/n9m/n9m0.jpg
// module id = K2fk
// module chunks = 1